import axios from 'axios'
// cookie
function setLoginCookies(data: {
  access_token: string
  refresh_token: string
  id: string
  url_name: string
}) {
  document.cookie = `access_token=${data.access_token}; path=/;`
  document.cookie = `refresh_token=${data.refresh_token}; path=/;`
  document.cookie = `last_client_id=${data.id}; path=/;`
  document.cookie = `last_client_urlname=${data.url_name}; path=/;`
}

// remove cookie
function deleteLoginCookies() {
  document.cookie = `access_token=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;`
  document.cookie = `refresh_token=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;`
  document.cookie = `last_client_id=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;`
  document.cookie = `last_client_urlname=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;`
}

export function readCookie(name: string) {
  const nameEQ = name + '='
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

// csrf token の付け替え
axios.defaults.xsrfCookieName = 'CSRF-TOKEN'
axios.defaults.xsrfHeaderName = 'X-CSRF-Token'
axios.defaults.withCredentials = true

// if api response is 401, redirect to toppage.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      deleteLoginCookies()
      window.location.href = '/admin/login'
      return Promise.reject(error)
    }
    return Promise.reject(error)
  },
)

const API_PREFIX = '/admin/api'
export const FETCH_KEYS = {
  clients: `${API_PREFIX}/clients`,
  fetchClient: (clientId: number) => `${API_PREFIX}/clients/${clientId}`,
  pageGroups: (clientId: number) =>
    `${API_PREFIX}/clients/${clientId}/page-groups`,
  pageGroup: (clientId: number, pageGroupId: number) =>
    `${API_PREFIX}/clients/${clientId}/page-groups/${pageGroupId}`,
  announces: (clientId: number) =>
    `${API_PREFIX}/clients/${clientId}/announces`,
  items: (clientId: number) =>
    `${API_PREFIX}/clients/${clientId}/items`,
  reportMails: (clientId: number) =>
    `${API_PREFIX}/clients/${clientId}/report-mails`,
  fetchCvList: (
    clientId: number,
    date: string,
    duplicate: boolean,
    is_test: boolean,
    startDate: string,
    endDate: string,
  ) =>
    `${API_PREFIX}/clients/${clientId}/analysis/cvlist?date=${date}&duplicate=${duplicate}&is_test=${is_test}&from=${startDate}&to=${endDate}`,
  fetchInviterList: (
    clientId: number,
    page: number,
    queryFilter: any,
  ): [string, Record<string, any>] => {
    const body: Record<string, any> = { page }
    for (const [key, value] of Object.entries(queryFilter)) {
      if (value === null || value === undefined || value === '') continue
      body[key] = value
    }
    return [`${API_PREFIX}/clients/${clientId}/analysis/inviter`, body]
  },
  fetchGuestList: (
    clientId: number,
    page: number,
    queryFilter: any,
  ): [string, Record<string, any>] => {
    const body: Record<string, any> = { page }
    for (const [key, value] of Object.entries(queryFilter)) {
      if (value === null || value === undefined || value === '') continue
      body[key] = value
    }
    return [`${API_PREFIX}/clients/${clientId}/analysis/guest`, body]
  },
  fetchAbout: (clientId: number) =>
    `${API_PREFIX}/clients/${clientId}/analysis/about`,
  fetchCrmScoringMatrix: (
    clientId: number,
    axis: 'r2_f2' | 'f2_m2',
    startDate: string,
    endDate: string,
    snapshotDate: string,
  ) =>
    `${API_PREFIX}/clients/${clientId}/crm_scoring/matrix?axis=${axis}&start_date=${startDate}&end_date=${endDate}&snapshot_date=${snapshotDate}`,
  fetchCrmScoringUsers: (
    clientId: number,
    axis: 'r2_f2' | 'f2_m2',
    startDate: string,
    endDate: string,
    cells: Array<[number, number]>,
    page: number,
    perPage: number,
    sortBy: string,
    sortOrder: string,
    snapshotDate: string,
    search: string,
  ) =>
    `${API_PREFIX}/clients/${clientId}/crm_scoring/users?axis=${axis}&start_date=${startDate}&end_date=${endDate}&cells=${encodeURIComponent(JSON.stringify(cells))}&page=${page}&per_page=${perPage}&sort_by=${sortBy}&sort_order=${sortOrder}&snapshot_date=${snapshotDate}&search=${encodeURIComponent(search)}`,
  fetchCrmScoringUserDetail: (clientId: number, simpleUserId: number, snapshotDate: string) =>
    `${API_PREFIX}/clients/${clientId}/crm_scoring/user_detail?simple_user_id=${simpleUserId}&snapshot_date=${snapshotDate}`,
}

export async function fetchBlacklists(clientId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/blacklists`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function createBlacklist(
  clientId: number,
  { suid, code, reason }: { suid?: string; code?: string; reason?: string },
) {
  return axios.post(
    `/admin/api/clients/${clientId}/blacklists`,
    { suid, code, reason },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
}

export async function deleteBlacklist(clientId: number, id: number) {
  const response = await axios.delete(
    `/admin/api/clients/${clientId}/blacklists/${id}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function fetcherWithAuth(key: string) {
  const response = await axios.get(key, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${readCookie('access_token')}`,
    },
  })
  return response.data
}

export async function fetcherWithAuthPost([url, body]: [string, any]) {
  const response = await axios.post(url, body, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${readCookie('access_token')}`,
    },
  })
  return response.data
}

export async function fetchClients() {
  // const credentials = `${process.env.BASIC_AUTH_USERNAME}:${
  //   process.env.BASIC_AUTH_PASSWORD
  // }`
  // const b64 = Buffer.from(credentials).toString('base64')
  const response = await axios.get('/admin/api/clients', {
    headers: {
      'Content-Type': 'application/json',
      // Authorization: `Basic ${b64}`
    },
  })
  return response.data.clients
}

export async function fetchClient(clientId: number) {
  const response = await axios.get(`/admin/api/clients/${clientId}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${readCookie('access_token')}`,
    },
  })
  return response.data.client
}

export async function createClient(
  name: string,
  urlName: string,
  email: string,
  password: string,
  passwordConfirmation: string,
  invyServiceUse: string,
  pageCreation: string,
) {
  const response = await axios.post('/admin/api/clients', {
    client: {
      name,
      url_name: urlName,
      invy_service_use: invyServiceUse,
      page_creation: pageCreation,
    },
    user: {
      email,
      password,
      password_confirmation: passwordConfirmation,
    },
  })
  return response.data.page_group
}

export async function cancelClient(client_id: number, pw: string) {
  const response = await axios.delete('/admin/api/clients/' + client_id, {
    data: {
      pw,
    },
  })
  return response.data
}

export async function checkDataExistence(
  value: string,
  type: 'name' | 'urlName' | 'email',
) {
  const response = await axios.post('/admin/api/dataexistence', { value, type })
  return response.data as boolean
}

export async function fetchItems(clientId: number) {
  const response = await axios.get(`/admin/api/clients/${clientId}/items`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${readCookie('access_token')}`,
    },
  })
  return response.data.items
}

export async function postItem(clientId: number, file: any, directory = '') {
  const data = new FormData()
  data.append('file', file)
  data.append('directory', directory)
  const response = await axios.post(
    `/admin/api/clients/${clientId}/items`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response
}

export async function deleteItem(clientId: number, itemId: number) {
  const response = await axios.delete(
    `/admin/api/clients/${clientId}/items/${itemId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response
}

export async function bulkDeleteItems(clientId: number, itemIds: number[]) {
  const { data } = await axios.post(
    `/admin/api/clients/${clientId}/items/bulk_destroy`,
    { item_ids: itemIds },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return data
}

export async function updateLINEMessage(clientId: number, message: string) {
  await axios.patch(
    `/admin/api/clients/${clientId}`,
    {
      client: {
        line_message: message,
      },
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
}

export async function updateMailSubject(clientId: number, subject: string) {
  await axios.patch(
    `/admin/api/clients/${clientId}`,
    {
      client: {
        mail_subject: subject,
      },
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
}

export async function updateClientPrefectureOrder(
  clientId: number,
  prefectureOrder: number[] | null,
) {
  await axios.patch(
    `/admin/api/clients/${clientId}`,
    {
      client: {
        prefecture_order: prefectureOrder,
      },
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
}

export async function updateClient(clientId: number, values: any) {
  await axios.patch(
    `/admin/api/clients/${clientId}`,
    {
      client: {
        ...values,
      },
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
}

export async function updateClientConf(clientId: number, data: any) {
  const converted = {
    coming_name: data.comingName,
    coming_mail: data.comingMail,
    coming_tel: data.comingTel,
    coming_other: data.comingOther,
    coming_address: data.comingAddress,
    shop_id: data.shopId,
    shop_prefecture: data.shopPrefecture,
    store_staff: data.storeStaff,
    store_other: data.storeOther,
    coming_password_required: data.comingPasswordRequired,
    use_guest_coupon_redirect: data.useGuestCouponRedirect,
    coming_display_from_name: data.comingDisplayFromName,
    coming_display_code: data.comingDisplayCode,
    coming_display_from_shop_name: data.comingDisplayFromShopName,
    password: data.password,
    privacypolicy: data.privacypolicy,
  }
  await axios.patch(
    `/admin/api/clients/${clientId}`,
    {
      client: converted,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
}

export async function updateMailConf(clientId: number, data: any) {
  const converted = {
    report_web_cv: data.report_web_cv,
    report_coming_cv: data.report_coming_cv,

    is_report_inviter_name: data.is_report_inviter_name,
    is_report_shop_name: data.is_report_shop_name,

    is_report_guest_name: data.is_report_guest_name,

    is_report_coming_mail: data.is_report_coming_mail,
    is_report_coming_tel: data.is_report_coming_tel,
    is_report_coming_address: data.is_report_coming_address,
    is_report_coming_other: data.is_report_coming_other,
    notify_guest_shop: data.notify_guest_shop,
    notify_inviter_shop: data.notify_inviter_shop,
  }
  await axios.patch(
    `/admin/api/clients/${clientId}`,
    {
      client: converted,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
}

export async function fetchPageGroup(clientId: number, pageGroupId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/page-groups/${pageGroupId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data.page_group
}

export async function updatePageGroup(
  clientId: number,
  pageGroupId: number,
  pageGroup: any,
  keyVisualFile?: any,
  logoFile?: any,
  incentiveImage?: any,
  incentiveImageGuest?: any,
) {
  const formData = new FormData()
  // 画像を編集しない画面から undefined で呼ばれたときは送らない。
  // 空文字を送るとサーバ側で「画像クリア」と解釈され、既存画像が消えてしまう。
  if (keyVisualFile !== undefined) formData.append('key_visual_file', keyVisualFile)
  if (logoFile !== undefined) formData.append('logo_file', logoFile)
  if (incentiveImage !== undefined) formData.append('incentive_image_file', incentiveImage)
  if (incentiveImageGuest !== undefined) {
    formData.append('incentive_image_guest_file', incentiveImageGuest)
  }
  formData.append('page_group', JSON.stringify(pageGroup))
  const response = await axios.patch(
    `/admin/api/clients/${clientId}/page-groups/${pageGroupId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response
}

export async function createPageGroup(
  clientId: number,
  pageType: string,
  campaignId: number,
) {
  const response = await axios.post(
    `/admin/api/clients/${clientId}/page-groups`,
    {
      pageType,
      campaignId,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function fetchPagePreview(pageGroupId: any, formValues: any) {
  const response = await axios.post(
    `/admin/api/preview`,
    {
      id: pageGroupId,
      formValues: JSON.stringify(formValues),
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function updateReportMail(
  clientId: number,
  reportMailId: number,
  name: string,
  send_to: string,
) {
  try {
    const response = await axios.patch(
      `/admin/api/clients/${clientId}/report-mails/${reportMailId}`,
      {
        report_mail: { name, send_to },
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${readCookie('access_token')}`,
        },
      },
    )
    return response.data
  } catch (error: any) {
    throw error.response?.data?.errors || ['エラーが発生しました']
  }
}

export async function createReportMail(
  clientId: number,
  name: string,
  send_to: string,
) {
  try {
    const response = await axios.post(
      `/admin/api/clients/${clientId}/report-mails`,
      {
        report_mail: { name, send_to },
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${readCookie('access_token')}`,
        },
      },
    )
    return response.data
  } catch (error: any) {
    throw error.response?.data?.errors || ['エラーが発生しました']
  }
}

export async function deleteReportMail(clientId: number, reportMailId: number) {
  const { data } = await axios.delete(
    `/admin/api/clients/${clientId}/report-mails/${reportMailId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return data
}

export async function deleteAllReportMail(clientId: number) {
  const response = await axios.delete(
    `/admin/api/clients/${clientId}/report-mails/`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function getReportData(
  clientId: number,
  reportType: any,
  startDate: string,
  endDate: string,
) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/reports/${reportType}.json?from=${startDate}&to=${endDate}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

// レポートCSVで一度に指定できる期間の上限(ヶ月)を取得する。
// 上限はクライアントのデータ量から決まるため、画面を開いたときにサーバーへ問い合わせる。
export async function getReportPeriodLimit(clientId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/reports/period_limit`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data.period_limit_months as number
}

export interface ReportsSummaryColumns {
  Header: string
  accessor: string
  className?: string
}

export interface ReportsSummaryResponse {
  data_columns: ReportsSummaryColumns[]
  data: Record<string, string | number | null>[]
  sum: Record<string, string | number | null>[]
}

export async function getReportsSummary(
  clientId: number,
  startDate: string,
  endDate: string,
): Promise<ReportsSummaryResponse> {
  const response = await axios.get<ReportsSummaryResponse>(
    `/admin/api/clients/${clientId}/reports/get_all_reports_summary?from=${startDate}&to=${endDate}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function getTestReportsSummary(clientId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/reports/get_test_reports_summary`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function getCVSummary(
  clientId: number,
  date: string,
  duplicate: boolean = true,
  is_test: boolean = false,
) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/cv-list?date=${date}&duplicate=${duplicate}&is_test=${is_test}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function getCVReportsSummary(
  clientId: number,
  startDate: string,
  endDate: string,
  duplicate: boolean,
) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/cv-list/custom?from=${startDate}&to=${endDate}&duplicate=${duplicate}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function getTotalClickReport(clientId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/reports/get_total_click_report`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data.total_report
}

export async function getTotalClickCV(clientId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/reports/get_total_click_report`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data.total_report
}

export async function login(email: string, password: string) {
  const response = await axios.post('/api/login', { user: { email, password } })
  const data = response.data
  if (!data.login) {
    throw new Error('Login failed')
  }
  setLoginCookies(data)
  return data
}

export async function logout() {
  const response = await axios.get('/api/logout', {
    headers: {
      Authorization: `Bearer ${readCookie('access_token')}`,
    },
  })
  deleteLoginCookies()

  return response.data
}

export async function deletePageGroup(clientId: number, pageGroupId: number) {
  const { data } = await axios.delete(
    `/admin/api/clients/${clientId}/page-groups/${pageGroupId}`,
    {
      headers: {
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return data
}

export async function deletePageGroupWithChildren(clientId: number, pageGroupId: number) {
  const { data } = await axios.delete(
    `/admin/api/clients/${clientId}/page-groups/${pageGroupId}/destroy_with_children`,
    {
      headers: {
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return data
}

export async function createAnnoune(clientId: number, announce: any) {
  const { data } = await axios.post(
    `/admin/api/clients/${clientId}/announces`,
    { announce },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return data
}

export async function updateAnnounce(
  clientId: number,
  id: number,
  announce: any,
) {
  const { data } = await axios.patch(
    `/admin/api/clients/${clientId}/announces/${id}`,
    { announce },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return data
}

export async function deleteAnnounce(clientId: number, id: number) {
  const { data } = await axios.delete(
    `/admin/api/clients/${clientId}/announces/${id}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return data
}

export async function fetchShops(clientId: number) {
  const response = await axios.get(`/admin/api/clients/${clientId}/shops`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${readCookie('access_token')}`,
    },
  })
  return response.data.shops
}

export async function createShop(clientId: number, shopData: any) {
  const response = await axios.post(
    `/admin/api/clients/${clientId}/shops`,
    {
      shop: shopData,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function deleteShop(clientId: number, shopId: number) {
  const { data } = await axios.delete(
    `/admin/api/clients/${clientId}/shops/${shopId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return data
}

export async function bulkDeleteShops(clientId: number, shopIds: number[]) {
  const { data } = await axios.post(
    `/admin/api/clients/${clientId}/shops/bulk_destroy`,
    { shop_ids: shopIds },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return data
}

export async function downloadShopsQrZip(
  clientId: number,
  shopIds: number[],
): Promise<Blob> {
  const response = await axios.post(
    `/admin/api/clients/${clientId}/shops/qr_zip`,
    { shop_ids: shopIds },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
      responseType: 'blob',
    },
  )
  return response.data
}

export async function fetchShop(clientId: number, shopId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/shops/${shopId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data.shop
}

export async function updateShop(clientId: number, shopId: number, shop: any) {
  const response = await axios.patch(
    `/admin/api/clients/${clientId}/shops/${shopId}`,
    {
      shop,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response
}

export async function fetchTemplates() {
  const response = await axios.get(`/admin/api/templates`, {
    headers: {
      Authorization: `Bearer ${readCookie('access_token')}`,
    },
  })
  return response.data.templates
}

export async function createByCsv(clientId: number, file: any) {
  const formData = new FormData()
  formData.append('file', file)
  const response = await axios.post(
    `/admin/api/clients/${clientId}/shops/csv_upload`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response
}

export async function fetchShopsOptions(clientId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/shop_options`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data.shops_options
}

export async function createShopsOption(clientId: number, data: any) {
  const response = await axios.post(
    `/admin/api/clients/${clientId}/shop_options`,
    {
      shop_option: {
        option_key: data.option_key,
        option_name: data.option_name,
        option_values: data.option_values,
      },
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function updateShopsOption(
  clientId: number,
  optionKey: string,
  data: any,
) {
  const response = await axios.patch(
    `/admin/api/clients/${clientId}/shop_options/${optionKey}`,
    {
      shop_option: {
        option_name: data.option_name,
        option_values: data.option_values,
      },
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function deleteShopsOption(clientId: number, optionKey: string) {
  const response = await axios.delete(
    `/admin/api/clients/${clientId}/shop_options/${optionKey}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function fetchInviterExport(clientId: number, queryFilter: any) {
  const body = Object.fromEntries(
    Object.entries(queryFilter).filter(
      ([key, value]) => value !== null && value !== undefined && value !== '',
    ),
  )

  const response = await axios.post(
    `/admin/api/clients/${clientId}/analysis/inviter_export`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

// キャンペーンポイントCSV(エバーライフ様専用)。
// 既存の inviter_export は署名URLを返すが、こちらはRailsがCSVを直接返すためBlobで受け取る。
// 集計期間はサーバ側で常にキャンペーン期間になるため、検索条件は送らない
export async function fetchCampaignPointExportCsv(clientId: number): Promise<Blob> {
  const response = await axios.post(
    `/admin/api/clients/${clientId}/analysis/campaign_point_export`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
      responseType: 'blob',
    },
  )
  return response.data as Blob
}

export async function fetchCrmScoringExportCsv(
  clientId: number,
  axis: 'r2_f2' | 'f2_m2',
  startDate: string,
  endDate: string,
  cells: Array<[number, number]>,
  simpleUserIds: number[] | null,
  snapshotDate: string,
  sortBy: string,
  sortOrder: string,
  search: string,
) {
  const params = new URLSearchParams({
    axis,
    start_date: startDate,
    end_date: endDate,
    cells: JSON.stringify(cells),
    snapshot_date: snapshotDate,
    sort_by: sortBy,
    sort_order: sortOrder,
    search,
  })
  if (simpleUserIds && simpleUserIds.length > 0) {
    params.append('simple_user_ids', JSON.stringify(simpleUserIds))
  }
  const response = await axios.get(
    `/admin/api/clients/${clientId}/crm_scoring/export_csv?${params.toString()}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function fetchGuestExport(clientId: number, queryFilter: any) {
  const body = Object.fromEntries(
    Object.entries(queryFilter).filter(
      ([key, value]) => value !== null && value !== undefined && value !== '',
    ),
  )

  const response = await axios.post(
    `/admin/api/clients/${clientId}/analysis/guest_export`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function fetchEmailNotices(clientId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/email_notices`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function fetchNotComingCouponCvList(clientId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/email_notices/not_coming_coupon_cv_list`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function fetchComingCouponCvList(clientId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/email_notices/coming_coupon_cv_list`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function fetchEmailNotice(
  clientId: number,
  emailNoticeId: number,
) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/email_notices/${emailNoticeId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function createEmailNotice(
  clientId: number,
  enduserEventId: number,
  to_type: string,
  subject: string,
  content: string,
  cta_url: string,
  kv_img_url: string,
  is_active: boolean,
  upper_limit: number,
  custom_css?: string,
) {
  const response = await axios.post(
    `/admin/api/clients/${clientId}/email_notices`,
    {
      email_notice: {
        enduser_event_id: enduserEventId,
        to_type: to_type,
        subject,
        body_json: {
          content,
          cta_url,
          kv_img_url,
          custom_css,
        },
        is_active,
        upper_limit,
      },
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function updateEmailNotice(
  clientId: number,
  noticeId: number,
  enduserEventId: number,
  to_type: string,
  subject: string,
  content: string,
  cta_url: string,
  kv_img_url: string,
  is_active: boolean,
  upper_limit: number,
  custom_css?: string,
) {
  const response = await axios.put(
    `/admin/api/clients/${clientId}/email_notices/${noticeId}`,
    {
      email_notice: {
        enduser_event_id: enduserEventId,
        to_type: to_type,
        subject,
        body_json: {
          content,
          cta_url,
          kv_img_url,
          custom_css,
        },
        is_active,
        upper_limit,
      },
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function deleteEmailNotice(
  clientId: number,
  emailNoticeId: number,
) {
  const response = await axios.delete(
    `/admin/api/clients/${clientId}/email_notices/${emailNoticeId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function copyEmailNotice(clientId: number, emailNoticeId: number) {
  const response = await axios.post(
    `/admin/api/clients/${clientId}/email_notices/${emailNoticeId}/copy`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

// enduser events
export async function fetchEnduserEvents(clientId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/enduser_events`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function fetchEnduserEventsNotComingCouponCvList(clientId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/enduser_events/not_coming_coupon_cv_list`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function fetchEnduserEventsComingCouponCvList(clientId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/enduser_events/coming_coupon_cv_list`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function fetchEnduserEvent(clientId: number, eventId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/enduser_events/${eventId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function createEnduserEvent(
  clientId: number,
  name: string,
  recordType: string,
  options: any,
) {
  const response = await axios.post(
    `/admin/api/clients/${clientId}/enduser_events`,
    { enduser_event: { name, record_type: recordType, options } },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function updateEnduserEvent(
  clientId: number,
  eventId: number,
  name: string,
  recordType: string,
  options: any,
) {
  const response = await axios.put(
    `/admin/api/clients/${clientId}/enduser_events/${eventId}`,
    { enduser_event: { name, record_type: recordType, options } },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function deleteEnduserEvent(clientId: number, eventId: number) {
  const response = await axios.delete(
    `/admin/api/clients/${clientId}/enduser_events/${eventId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function fetchEmailNoticesPreference(clientId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/email_notices_preference`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}
export async function updateEmailNoticesPreference(
  clientId: number,
  data: any,
) {
  const response = await axios.put(
    `/admin/api/clients/${clientId}/email_notices_preference`,
    { email_notices_preference: data },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function fetchCouponContents(clientId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/coupon_contents`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function fetchCouponContent(clientId: number, couponContentId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/coupon_contents/${couponContentId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function createCouponContent(
  clientId: number,
  to_type: string,
  title: string,
  logo_url: string,
  url: string,
  content: string,
  is_active: boolean,
) {
  const response = await axios.post(
    `/admin/api/clients/${clientId}/coupon_contents`,
    {
      coupon_content: {
        to_type,
        title,
        body_json: {
          logo_url,
          url,
          content,
        },
        is_active,
      },
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function updateCouponContent(
  clientId: number,
  couponContentId: number,
  to_type: string,
  title: string,
  logo_url: string,
  url: string,
  content: string,
  is_active: boolean,
) {
  const response = await axios.put(
    `/admin/api/clients/${clientId}/coupon_contents/${couponContentId}`,
    {
      coupon_content: {
        to_type,
        title,
        body_json: {
          logo_url,
          url,
          content,
        },
        is_active,
      },
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function copyCouponContent(clientId: number, couponContentId: number) {
  const response = await axios.post(
    `/admin/api/clients/${clientId}/coupon_contents/${couponContentId}/copy`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function deleteCouponContent(clientId: number, couponContentId: number) {
  const response = await axios.delete(
    `/admin/api/clients/${clientId}/coupon_contents/${couponContentId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function fetchCouponList(
  clientId: number,
  duplicate: boolean,
  is_test: boolean,
) {
  const response = await axios.get(
    `${API_PREFIX}/clients/${clientId}/analysis/coupon_list?duplicate=${duplicate}&is_test=${is_test}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

// users
export async function fetchUserList(clientId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/users`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function fetchCurrentUser(clientId: number) {
  const response = await axios.get(
    `/admin/api/clients/${clientId}/users/current`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function createUser(
  clientId: number,
  email: string,
  admin_type: number,
  password: string,
  passwordConfirmation: string,
) {
  try {
    const response = await axios.post(
      `/admin/api/clients/${clientId}/users`,
      {
        users: {
          email: email,
          admin_type: admin_type,
          password: password,
          password_confirmation: passwordConfirmation,
        },
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${readCookie('access_token')}`,
        },
      },
    )
    return response.data
  } catch (error: any) {
    throw error.response?.data?.errors || ['エラーが発生しました']
  }
}

export async function updateUser(
  clientId: number,
  userId: number,
  attrs: { email?: string; admin_type?: number },
) {
  try {
    const response = await axios.put(
      `/admin/api/clients/${clientId}/users/${userId}`,
      {
        users: attrs,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${readCookie('access_token')}`,
        },
      },
    )
    return response.data
  } catch (error: any) {
    throw error.response?.data?.errors || ['エラーが発生しました']
  }
}

export async function updateUserPassword(
  clientId: number,
  userId: number,
  currentPassword: string,
  password: string,
  passwordConfirmation: string,
) {
  try {
    const response = await axios.patch(
      `/admin/api/clients/${clientId}/users/${userId}/password`,
      {
        users: {
          current_password: currentPassword,
          password: password,
          password_confirmation: passwordConfirmation,
        }
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${readCookie('access_token')}`,
        },
      },
    )
    return response.data
  } catch (error: any) {
    throw error.response?.data?.errors || ['エラーが発生しました']
  }
}

export async function deleteClientUser(clientId: number, userId: number) {
  const response = await axios.delete(
    `/admin/api/clients/${clientId}/users/${userId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response.data
}

export async function updateSwitchover(
  clientId: number,
  pageGroupId: number,
  data: {
    end_date: string
    next_page_group_id?: number
    next_start_date?: string
  },
) {
  const response = await axios.patch(
    `/admin/api/clients/${clientId}/page-groups/${pageGroupId}/switchover`,
    data,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${readCookie('access_token')}`,
      },
    },
  )
  return response
}
